import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';
import { withFormik, Field, Form, getIn } from 'formik';
import { FormikTimeInput } from '../../components';
import { updateAdvanceSettingRequest } from '../../requests/advanceSettings';

// Convert time string (22:00) to integer (2200)
const timeToInteger = (timeString) => {
  if (timeString === '00:00') return 0;
  if (!timeString) return null;
  return parseInt(timeString.replace(':', ''), 10);
};

// Convert integer (2200) to time string (22:00)
const integerToTime = (integer) => {
  if (integer === 0) return '00:00';
  if (!integer) return null;
  const str = integer.toString().padStart(4, '0');
  return `${str.slice(0, 2)}:${str.slice(2, 4)}`;
};

const FormNightShiftSettings = ({ errors, touched, setFieldValue, isSubmitting }) => {

  return (
    <Col md={11}>
      <Form className="d-flex flex-column justify-content-end mt-2">
        <p>Configure el rango de horario para considerar un turno como nocturno en el reporte de turnos.</p>
        <Row>
          <Col md={4} className="d-flex flex-column">
            <Field name="advanceSetting[1]integer_value">
              {({ field }) => (
                <FormikTimeInput
                  {...field}
                  label="Hora Inicio Turno Nocturno"
                  onChange={time => setFieldValue(field.name, time)}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={4} className="d-flex flex-column">
            <Field name="advanceSetting[2]integer_value">
              {({ field }) => (
                <FormikTimeInput
                  {...field}
                  label="Hora Fin Turno Nocturno"
                  onChange={time => setFieldValue(field.name, time)}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={1} />
          <Col md={3} className="d-flex flex-column">
            <Button type="submit" variant="primary" disabled={isSubmitting} className="w-100 mt-auto">
              GUARDAR
            </Button>
          </Col>
        </Row>
      </Form>
    </Col>
  );
};

const mapStateToProps = state => {
  const { user, currentEmployee } = state.auth;
  return { user, currentEmployee };
};

const initialValues = ({ advanceSetting }) => {
  const base = (advanceSetting || []).map(s => ({
    id: s.id,
    code: s.code,
    text_value: s.text_value,
    integer_value: integerToTime(s.integer_value)
  }));
  return { advanceSetting: base };
};

const handleSubmit = (values, { props, setSubmitting }) => {
  const { dispatch, handleSuccessUpdate } = props;

  const base = (values.advanceSetting || []).map(s => ({
    id: s.id,
    code: s.code,
    text_value: s.text_value,
    integer_value: timeToInteger(s.integer_value)
  }));
  if (values['advanceSetting[1]integer_value'] !== undefined) base[1].integer_value = values['advanceSetting[1]integer_value'];
  if (values['advanceSetting[2]integer_value'] !== undefined) base[2].integer_value = values['advanceSetting[2]integer_value'];


  updateAdvanceSettingRequest(base[1].id, {
    dispatch,
    params: snakeCaseKeys({ advanceSetting: { integerValue: base[1].integer_value } }),
    formData: true,
    successCallback: () => {
      updateAdvanceSettingRequest(base[2].id, {
        dispatch,
        params: snakeCaseKeys({ advanceSetting: { integerValue: base[2].integer_value } }),
        formData: true,
        successCallback: () => {
          setSubmitting(false);
          handleSuccessUpdate('Configuración modificada con éxito');
        }
      });
    }
  });
};

export default withRouter(
  connect(mapStateToProps)(
    withFormik({
      mapPropsToValues: params => initialValues(params),
      handleSubmit,
      enableReinitialize: true,

    })(FormNightShiftSettings)
  )
);